<template>
<!-- card mode -->
  <v-card class="roma-card full-h roma-elevation-3" @click="redirect(task)">
    <v-card-text class="full-h">
      <v-container class="pa-0">
        <!-- header -->
        <v-row no-gutters="" class="d-flex justify-end mb-5" >
          <div elevation="0" cols="auto" class="ml-5" x-small rounded
            :class="{
              'pendiente-bg': task.state != 0 && task.state != 1,
              'en-progreso-bg': task.state == 1,
              'completa-evaluada-bg': task.state == 0
            }">
              <h5 class="font-inter subtitulo-5" v-if="task.state == 0" style="color: #ff9102">ENVIADO</h5>
              <h5 class="font-inter subtitulo-5" v-else-if="task.state == 1" style="color: #4caf50">EVALUADO</h5>
              <h5 class="font-inter subtitulo-5" v-else style="color: #3a8fce" >POR ENVIAR</h5>
          </div>

          <div class="ml-3"
            v-if="task.taskCheckedDate">
            <h5 class="font-inter font-weight-500 parrafo-2">
              {{ formatDate(task.taskCheckedDate) }}
            </h5>
          </div>

          
        </v-row>

        <v-row no-gutters class="mb-1">
            <v-col>
              <span class="ml-3 px-2 subtitulo-5 py-1 px-2 font-inter" :style="{ color: '#743085', background: '#F1E6FF', 'border-radius': '8px'}">
                {{ task.lessonTO.category.abbreviation }}
              </span>
            </v-col>
        </v-row>

        <!-- subheader -->
        <v-row no-gutters class="mb-5">
          <v-col>
            <strong class="roma-card__subject px-3 titulo-5 color-neutro-0">
              {{ capitalizeFirstLetter(task.lessonTO.subject.name.toLowerCase()) }}
            </strong>
          </v-col>
        </v-row>

        <v-row no-gutters="" class="mt-1 ml-3 mb-1">
          <v-col cols="auto">
            <span class="font-inter subtitulo-2 color-neutro-1">
              {{ task.lessonTO.code}}
            </span>
          </v-col>
        </v-row>

        <v-row no-gutters="" class="ml-3 mb-5">
           <v-col cols="auto">      
                <span
                  title="Evaluación Progresiva Diagnostica"
                  class="font-inter titulo-3 color-neutro-0"
                >
                  {{ task.lessonTO.title }} - {{ task.activityTO.title }}
                </span>
                
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
  <!-- 
  <span v-if="!!task.taskCheckedDate" class="roma-card__pre-title mx-3">
      {{ formatDate(task.taskCheckedDate) }}
  </span>
  <span v-if="!!task.score && (!task.achievement || task.achievement === 0)" style="color: #0000FF" class="roma-card__header">
      Nota: {{ task.score }}
  </span>
  <span v-if="!!task.achievement && (!task.score || task.score===0)" style="color: #0000FF" class="roma-card__header">
      Logro: {{ task.achievement }}%
  </span>
  <span v-if="!!task.score && !!task.achievement && task.score>0 && task.achievement>0" style="color: #0000FF" class="roma-card__header">
      Nota: {{ task.score }} / {{ task.achievement }}%
  </span>
  -->
</template>

<script>
import Utility from "@/mixins/Utility";
import moment from 'moment'
export default {
  props: {
    task: {
      required: true,
      type: Object
    }
  },
  mixins: [Utility],
  methods: {
    redirect(task) {

      if(!task.taskId){

          this.$router.push({
            name: "Lesson Detail",
            params: {
              id: task.lessonTO.lessonId
            }
          });

      }else{

        this.$router.push({
          name: "TaskDetail",
          params: { id: task.taskId }
        });

      }

    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/generals.scss';
.pendiente-bg{
    background-color: #F5F9FC !important;
    pointer-events: none;
  }
.en-progreso-bg{
  background-color: rgba(251, 140, 0, 0.05) !important;
  pointer-events: none;
}
.completa-evaluada-bg{
  background-color: rgba(0, 186, 52, 0.05) !important;
  pointer-events: none;
}

.task_list_item {
  margin-top: 0.5rem;
  width: 100%;
  padding-bottom: 0%;
  background: #ffffff;
  border-radius: 5px;
  //   padding: 1rem;
  // box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
  //     0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.task-title{
 color: #3a8fce !important;
}

.roma-card__pre-title,
.roma-card__header {
  font-size: 14px;
}
</style>
